export default __webpack_public_path__ + "static/media/first-payment.56778ace.svg";